const $ = jQuery;

// Gravity forms data
const event_forms = [12, 14]; // Nested form IDs
const price_field_class = "event_price"; // Class name for the price field

// Check if value is empty, zero, or the merge tag placeholder
function _is_empty(value) {
  // Extract numeric value for comparison
  let numericValue = 0;
  if (value && !value.includes("{Parent:") && value !== "") {
    // Remove currency symbols and format
    const cleaned = value
      .toString()
      .replace(/[^\d.,]/g, "")
      .replace(",", ".");
    // Convert to number
    numericValue = parseFloat(cleaned) || 0;
  }

  return (
    !value ||
    value === "" ||
    value.includes("{Parent:") ||
    value === 0 ||
    value === "€ 0,00" ||
    numericValue === 0
  );
}

// Hide the price field if it is empty
function hide_price_if_empty() {
  const price_fields = $(`.${price_field_class}`);
  price_fields.each(function () {
    const field = $(this);
    let input = field.find(
      "input[type='text'], input[type='number'], input[type='hidden']",
    );
    const fieldValue = input.val() || "";

    const isEmpty = _is_empty(fieldValue);

    if (isEmpty) {
      field.hide();
    } else {
      field.show();
    }
  });
}

export default () => {
  $(document).on("gform_post_render", function (event, formId) {
    if (event_forms.includes(formId)) {
      setTimeout(hide_price_if_empty, 50); // Small delay to ensure Gravity Wiz has populated the value
    }
  });
};
